import React, { useEffect, useState } from "react"
import "./_cookiesPopup.scss"

export const CookiesPopup = ({lang}) => {
  const [isOpen, setIsOpen] = useState(true)

  useEffect(()=>{
    if(document.cookie.includes('accept-cookies=true')){
      setIsOpen(false);
    }
  }, []);

  if(!isOpen) return null

  const handleClose = () => {
    document.cookie = 'accept-cookies=true; path=/';
    setIsOpen(false);
  }

  return (
    <div className="cookies-popup-wrapper">
      <div className="container cookies-popup-box">
        <button className="close-button" onClick={handleClose}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z"/></svg>
          <span className="sr-only">Close Button</span>
        </button>
        {lang === "ID" ? (
          <p>Website ini menggunakan cookies untuk memberikan pengalaman yang lebih baik, menampilkan konten yang relevan, serta memudahkan akses fitur. Dengan melanjutkan penggunaan situs ini, Anda menyetujui penggunaan cookies sesuai dengan <a href="/privacy-policy/" target="_blank">kebijakan privasi</a> dan ketentuan yang berlaku.</p>
        ):(
          <p>This website uses cookies to enhance your browsing experience, deliver more relevant content, and simplify access to features. By continuing to use this site, you agree to the use of cookies in accordance with our <a href="/privacy-policy/" target="_blank">Privacy Policy</a> and the terms that apply.</p>
        )}
      </div>
    </div>
  )
}
